import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { padNumber } from '../../lib/Utility';

@Component({
    selector: 'app-meter-value-display',
    templateUrl: './meter-value-display.component.html',
    styleUrls: ['./meter-value-display.component.scss'],
})
export class MeterValueDisplayComponent {
    @Input() value = 12345;
    @Input() icon = 'lightning';
    @Input() title = this.translate.instant(
        'screens.dashboard.meterDetail.labels.VALUE_CONSUMPTION'
    );
    @Input() unit = 'kWh';
    @Input() forHeader = false;

    padNumberInternal = padNumber;

    constructor(private translate: TranslateService) {}
}
